module.exports = __webpack_public_path__ + "img/Pizza & Prep.bac5c5d6.svg";